import React, { Component } from 'react';

import { InputBlock } from 'components/input';
import Dripping from 'modules/content/components/dripping/Dripping';
import PropTypes from 'prop-types';

class DrippingGroup extends Component {
  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    labelValue: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    submitted: PropTypes.bool,
    value: PropTypes.object,
    forceUpdate: PropTypes.func
  };

  static defaultProps = {
    description: 'dripping.description',
    labelValue: 'dripping.title',
    value: {}
  };

  forceParentUpdate() {
    const { forceUpdate } = this.props;

    if (forceUpdate) {
      forceUpdate();
    }
  }

  onChange(drippingKey, drippingValue) {
    const { name, onChange } = this.props;
    let { value } = this.props;

    if (
      drippingKey === 'liberationType' &&
      drippingValue === value.liberationType
    ) {
      value = {};
    } else if (drippingKey === 'hasDuration' && drippingValue === false) {
      delete value.durationDays;
    }

    value[drippingKey] = drippingValue;

    onChange && onChange({ target: { name, value } });

    if (drippingKey === 'hasDuration') {
      this.forceParentUpdate();
    }
  }

  render() {
    const {
      className,
      description,
      labelValue,
      name,
      submitted,
      value,
      ...props
    } = this.props;

    return (
      <InputBlock name={name} submitted={submitted} {...props}>
        <Dripping
          {...props}
          name={name}
          value={value}
          className={className}
          labelValue={labelValue}
          description={description}
          hasDuration={value.hasDuration}
          durationDays={value.durationDays}
          liberationDate={value.liberationDate}
          liberationDays={value.liberationDays}
          liberationType={value.liberationType}
          changeLiberationType={(liberationType) =>
            this.onChange('liberationType', liberationType)
          }
          changeLiberationDays={(e) =>
            this.onChange('liberationDays', e.target.value)
          }
          changeHasDuration={(hasDuration) =>
            this.onChange('hasDuration', hasDuration)
          }
          changeLiberationDate={(liberationDate) =>
            this.onChange('liberationDate', liberationDate)
          }
          changeDurationDays={(durationDays) =>
            this.onChange('durationDays', durationDays)
          }
        />
      </InputBlock>
    );
  }
}

export default DrippingGroup;
